import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  listTitle: {
    width: 174,
    height: 24,
    marginTop: 32,
  },
  searchBar: {
    width: '100%',
    height: 32,
    marginTop: 28,
    borderRadius: 6,
  },
  usageTitle: {
    width: 174,
    height: 24,
    marginTop: 43.9,
  },
  usageSubtitle: {
    width: 248,
    height: 15.36,
    marginTop: 10.32,
  },
  tabItemStyle: {
    width: 91.67,
    height: 35.42,
    borderRadius: 17.3,
    marginRight: 12.7,
  },
  separator: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorNine,
    marginBottom: 8.3,
    marginTop: 24.7,
  }),
  licencesCardBodyItemCircle: {
    width: 40,
    height: 40,
    borderRadius: 28,
    marginRight: 18,
  },
  licencesUsageCardBodyItemSquare: {
    width: '100%',
    height: 11.52,
  },
  licencesUsageCardBodyItemSecondSquare: {
    width: '100%',
    height: 11.52,
    marginTop: 10,
  },
  licencesCardBodyItemSquare: {
    width: 201,
    height: 12,
  },
  licencesCardBodyItemMiddleSquare: {
    width: '100%',
    height: 12,
    marginVertical: 11.52,
  },
  licencesCardBodyItemLastSquare: {
    width: 142,
    height: 12,
  },
});
